"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var cssVars_1 = require("../helpers/cssVars");
var breakpointMinMax = function (_a) {
    var _b = _a.css, css = _b === void 0 ? null : _b, _c = _a.min, min = _c === void 0 ? null : _c, _d = _a.max, max = _d === void 0 ? null : _d;
    if (min && max) {
        return "@media(min-width: " + cssVars_1.cssVars.breakpoints[min] + "px) and (max-width:  " + cssVars_1.cssVars.breakpoints[max] + "px) {" + css + "}";
    }
    if (min) {
        if (cssVars_1.cssVars.breakpoints[min] > 0) {
            return "@media(min-width: " + cssVars_1.cssVars.breakpoints[min] + "px) {" + css + ";}";
        }
        return css + ";";
    }
    if (max) {
        return "@media(max-width: " + cssVars_1.cssVars.breakpoints[max] + "px) {" + css + "}";
    }
    return null;
};
exports.default = breakpointMinMax;
